export function Logo({ width = 120 }: { width?: number }) {
  const height = Math.round(width / 3);
  return (
    <span className="inline-block">
      <img src="/logo.svg" alt="Tahi" width={width} height={height} className="light:hidden" />
      <img
        src="/logo-on-light.svg"
        alt=""
        width={width}
        height={height}
        className="hidden light:block"
      />
    </span>
  );
}
